///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpParams, HttpStatusCode } from '@angular/common/http';
import { EMAIL_VERIFICATION_API, EMAIL_VERIFICATION_CONSTANTS } from './email-verification.constants';
import { Observable } from 'rxjs';
import { IGNORE_HTTP_ERRORS } from '../blocks/interceptor/errorhandler.interceptor';

@Injectable({
    providedIn: 'root'
})
export class EmailVerificationService {
    private readonly http = inject(HttpClient);

    generateTokenAndSendToEmail(): Observable<void> {
        return this.http.post<void>(EMAIL_VERIFICATION_API.GENERATION, {
            baseUrl: this.getBaseUrl()
        });
    }

    validateToken(token: string): Observable<void> {
        return this.http.get<void>(EMAIL_VERIFICATION_API.VALIDATION, {
            context: new HttpContext().set(IGNORE_HTTP_ERRORS, [HttpStatusCode.BadRequest]),
            params: new HttpParams().set(EMAIL_VERIFICATION_CONSTANTS.TOKEN_PARAM_NAME, token)
        });
    }

    private getBaseUrl(): string {
        const { protocol, hostname, port } = window.location;
        return `${protocol}//${hostname}${port ? ':' + port : ''}`;
    }
}
